// app/javascript/charts/donutChart.js
function createDonutChart(canvasId, data = { users: 0, synced: 0, unsynced: 0 }) {
  const ctx = document.getElementById(canvasId);
  const chartData = {
    labels: ['Users', 'Synced', 'Un-Synced'],
    datasets: [{
      data: [data.users, data.synced, data.unsynced],
      backgroundColor: ['#2486d2', '#48a54d', '#001f41'],
      borderWidth: 0,
      cutout: '70%'
    }]
  };

  return new Chart(ctx, {
    type: 'doughnut',
    data: chartData,
    options: {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          titleColor: '#333',
          bodyColor: '#333'
        }
      }
    }
  });
}

export { createDonutChart };
